import styled from '@emotion/styled';
import React from 'react';

interface SwitchProps {
  label?: string;
  value: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export function Switch({ label, value, onChange }: SwitchProps) {
  return (
    <Container>
      {label}
      <Checkbox type="checkbox" checked={value} onChange={onChange} />
      <Slider />
    </Container>
  );
}

const Slider = styled.span`
  position: relative;
  width: 28px;
  height: 8px;
  border-radius: 5px;
  background-color: ${(props) => props.theme.colors.purple[20]};
  transition: background-color 0.2s;
  flex-shrink: 0;

  &::before {
    position: absolute;
    content: '';
    height: 16px;
    width: 16px;
    left: 0;
    top: calc(50% - 8px);
    border-radius: 16px;
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.4);
    background-color: ${(props) => props.theme.colors.purple[50]};
    transition:
      background-color 0.2s ease-out,
      transform 0.2s,
      box-shadow 0.3s;
  }
`;

const Checkbox = styled.input`
  position: absolute;
  pointer-events: none;
  width: 0;
  height: 0;
  opacity: 0;

  &:checked + ${Slider} {
    background-color: ${(props) => props.theme.colors.orange[20]};
  }

  &:checked + ${Slider}:before {
    transform: translateX(12px);
    background-color: ${(props) => props.theme.colors.orange[100]};
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.4);
  }

  &:focus-visible + ${Slider} {
    box-shadow:
      0 0 0 1px white,
      0 0 0 3px #ebe7eb;
  }
`;

const Container = styled.label`
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  font-size: 14px;
  color: ${(props) => props.theme.typography.colorPrimary};
  white-space: nowrap;

  &:hover ${Checkbox}:not(:checked) + ${Slider}::before {
    background-color: ${(props) => props.theme.colors.purple[60]};
  }

  &:hover ${Checkbox}:checked + ${Slider}::before {
    background-color: ${(props) => props.theme.colors.orange[120]};
  }
`;
